import { Input as AntInput } from 'antd';
import InternalInput from "./Input";
import Search from "./Search";
import Password from "./Password";
import TextArea from "./TextArea";
export * from 'antd/es/input';
var Input = InternalInput;
Input.Group = AntInput.Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
Input.OTP = AntInput.OTP;
export default Input;